import { Box, Container, Paper, Typography } from '@mui/material'
import { solutions } from '../../data/landing'

import coffee from '../../assets/images/coffee-machine.jpeg'
import protein from '../../assets/images/protein-maker.png'
import food from '../../assets/images/food-kiosk.png'

export default function Solutions() {

  const images = {
    'Coffee Machine': coffee,
    'Protein Shake Machine': protein,
    'Food Kiosk': food,
  }

  return (
    <Box id="solutions" sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.5)' }}>
          Solutions
        </Typography>

        <Typography variant="h3" sx={{ fontWeight: 700, mb: 4 }}>
          Vending options we can install
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: '1fr 1fr 1fr',
            },
            gap: 3,
          }}
        >
          {solutions.map((item) => (
            <Paper
              key={item.title}
              sx={{
                p: 3,
                borderRadius: 4,
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(255,255,255,0.08)',
                color: '#fff',
                height: '80%',
                transition: '0.3s',
                '&:hover': {
                  transform: 'translateY(-6px)',
                },
              }}
            >
              <Box
                component="img"
                src={images[item.title]}
                alt={item.title}
                sx={{
                  width: '100%',
                  objectFit: 'cover',
height: '100%',
                  borderRadius: 3,
                  mb: 3,
                  background: 'rgba(255,255,255,0.02)',
                  p: 2,
                }}
              />

              <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                {item.title}
              </Typography>

              <Typography sx={{ color: 'rgba(255,255,255,0.72)', lineHeight: 1.7 }}>
                {item.text}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  )
}